/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { SearchableSelectView, type SearchableSelectViewProps } from './SearchableSelectView';

export type SearchableSelectProps = Omit<SearchableSelectViewProps, 'labels'>;

/** Host locale adapter; keyboard, validation and portal behavior share one renderer. */
export const SearchableSelect: React.FC<SearchableSelectProps> = (props) => {
    const t = useTranslation();
    return <SearchableSelectView {...props} labels={{
        searchPlaceholder: t.common.searchPlaceholder, search: t.common.search, noData: t.common.noData,
    }} />;
};
